
export function parseExcelPaste(content: string) {
  const rows = content
    .trim()
    .split("\n");


  return rows.map(row => {
    const separator =
      row.includes("\t")
        ? "\t"
        : row.includes(";")
          ? ";"
          : ",";

    const cols = row.split(separator).map(col => col.trim());

    return {
      email: cols[0],
      licence: cols[1],
      lastName: cols[2],
      firstName: cols[3],
      gender: cols[4],
      nationality: cols[5],
      birthDate: cols[6],
      category: cols[7],
      clubNumber: cols[8],
      clubName: cols[9],
    };
  });
}

